<app-toolbar-search></app-toolbar-search>
<div class="magic-link-container" *ngIf="showMagicLinkButton; else redirecting">
  <h1 class="title">{{"WelcomeBack!" | translate}}</h1>
  <p class="subtitle">{{"ClickTheButtonBelowToAccessYourAccount." | translate}}</p>
  <button 
    mat-flat-button 
    class="action-button"
    (click)="handleMagicLinkToken()"
    [disabled]="loading"
  >
    <ng-container *ngIf="!loading; else loadingTemplate">
      {{  "AccessPortal" | translate }}
    </ng-container>
    <ng-template #loadingTemplate>
      <mat-spinner diameter="24" class="button-spinner"></mat-spinner>
    </ng-template>
  </button>
</div>

<ng-template #redirecting>
  <div class="redirecting-container">
    <mat-spinner [diameter]="50" color="accent"></mat-spinner>
    <p class="redirecting-text">
      {{ "RedirectingToClientPortal" | translate }}
    </p>
  </div>
</ng-template>
